<script>
import {DateUtil} from '@/utils/date.js'
import {PlannRoute} from '@/utils/planningRoute.js'
import dialog from '@/components/Dialog'
export default {
  components: {'v-dialog': dialog},
  data () {
    return {
      showDialog: false,
      dialogOption: {
        showNo: true,
        text: '確定している便ですが、実行しますか？',
        cancelButtonText: 'いいえ',
        confirmButtonText: 'はい'
      },
      // 选择的时的集合
      hourList: [],
      // 选择的分的集合
      minuteList: [],
      //  便経由地情報数组
      shiftPasspoints: [],
      // 经由地的个数
      passpointNum: 0,
      // キャンセル待ちList
      toCheckList: [],
      // 所选车辆定員数
      passengerNum: 3,
      //  获取被选中的キャンセル待ち预约者情报数组
      shiftReservationInfos: [],
      shiftPasspointsTemp: [],
      // 时间校验标志位
      timeValidateFlag: false,
      timeError: false,
      shiftTimeError: false
    }
  },
  props: {
    // 行归flag:默认为行
    goBackFlag: { type: String, default: '0' }
  },
  watch: {
    // 如果需要定員数随所选车辆变化时，可以添加对vehicleId进行监听，然后调用 this.getShiftPasspoints()

    hourList () {
      this.watchHourMinuteValidate()
    },
    minuteList () {
      this.watchHourMinuteValidate()
    }
  },
  created () {
    this.getShiftPasspoints()
  },
  methods: {
    // 时间校验
    timeValidate () {
      if (this.goBackFlag === '0') {
        if (this.hourList[this.hourList.length - 1] === undefined ||
          this.minuteList[this.minuteList.length - 1] === undefined) {
          this.timeValidateFlag = true
          return false
        }
      } else if (this.goBackFlag === '1') {
        if (this.hourList[0] === undefined ||
          this.minuteList[0] === undefined) {
          this.timeValidateFlag = true
          return false
        }
      }
      return true
    },
    // 实时监控时分的校验
    watchHourMinuteValidate () {
      // alert(this.hourList[0])
      if (this.goBackFlag === '0') {
        if (this.hourList[this.hourList.length - 1] !== undefined &&
           this.minuteList[this.minuteList.length - 1] !== undefined) {
          this.timeValidateFlag = false
        }
      } else if (this.goBackFlag === '1') {
        if (this.hourList[0] !== undefined &&
            this.minuteList[0] !== undefined) {
          this.timeValidateFlag = false
        }
      }
    },
    // 根据具体情况整合经由地集合数据shiftPasspoints
    getShiftPasspoints () {
      // 请求后台flag=ture
      this.shiftPasspoints = []
      let shiftDetail = JSON.parse(sessionStorage.getItem('shiftDetail'))
      // 过滤session中路经由地，只剩停留所
      this.shiftPasspointsTemp = shiftDetail.shiftPasspoints.filter(item =>
        (item.routeType === '0')
      )
      this.shiftPasspointsTemp.forEach(item => {
        item.arrivePassengers = []
        item.stopFlag = true
        // item.showPassengers = false
      })
      this.toCheckList = JSON.parse(sessionStorage.getItem('toCheckList'))
      // 依此添加乘客到ルート中
      let sum = 0
      // 经由地个数（自宅或地图选择）
      let passpointNum = 0
      // 被选中的等待预约的个数
      let toCheckNum = 0
      for (let i = 0; i < this.toCheckList.length; i++) {
        if (sum >= this.passengerNum) {
          break
        } else {
          if (sum + this.toCheckList[i].passengerNumber <= this.passengerNum) {
            sum = sum + this.toCheckList[i].passengerNumber
            this.shiftReservationInfos[toCheckNum] = this.toCheckList[i]
            toCheckNum++
            // 行き(将乘车经由地放到出发点与第一个停留所之间)
            if (this.goBackFlag === '0') {
              let passenger = {}
              passenger.name = this.toCheckList[i].userName
              passenger.reserveId = this.toCheckList[i].reserveId
              passenger.routeType = '1'
              if (this.toCheckList[i].startPlaceType === 1) {
                passenger.stationLat = this.toCheckList[i].homeLat
                passenger.stationLng = this.toCheckList[i].homeLng
                passenger.arrivePassengers = []
                passenger.stopFlag = true
                this.shiftPasspointsTemp.splice(1, 0, passenger)
                passpointNum++
              } else {
                if (this.toCheckList[i].startPlaceType === 2) {
                  for (let j = 0; j < this.shiftPasspointsTemp.length; j++) {
                    if (this.shiftPasspointsTemp[j].stationId === this.toCheckList[i].startStationId) {
                      if (this.shiftPasspointsTemp[j].arrivePassengers === undefined || this.shiftPasspointsTemp[j].arrivePassengers.length === 0 || this.shiftPasspointsTemp[j].arrivePassengers === null) {
                        let arrivePassengers = []
                        let tempPassenger = {}
                        tempPassenger.name = this.toCheckList[i].userName
                        tempPassenger.reserveId = this.toCheckList[i].reserveId
                        arrivePassengers[0] = tempPassenger
                        this.shiftPasspointsTemp[j].arrivePassengers = arrivePassengers
                      // this.shiftPasspoints[i].showPassengers = true
                      // passpointNum++
                      } else {
                        let tempPassenger = {}
                        tempPassenger.name = this.toCheckList[i].userName
                        tempPassenger.reserveId = this.toCheckList[i].reserveId
                        this.shiftPasspointsTemp[j].arrivePassengers[this.shiftPasspointsTemp[j].arrivePassengers.length] = tempPassenger
                      }
                      break
                    }
                  }
                } else {
                  passenger.stationLat = this.toCheckList[i].startPlaceLat
                  passenger.stationLng = this.toCheckList[i].startPlaceLng
                  passenger.arrivePassengers = []
                  passenger.stopFlag = true
                  this.shiftPasspointsTemp.splice(1, 0, passenger)
                  passpointNum++
                }
              }
            } else {
              // 帰り(将降车经由地放到终点与最后一个停留所之间)
              let passenger = {}
              passenger.name = this.toCheckList[i].userName
              passenger.reserveId = this.toCheckList[i].reserveId
              passenger.routeType = '1'
              for (let j = 0; j < this.shiftPasspointsTemp.length; j++) {
                if (this.shiftPasspointsTemp[j].stationId === this.toCheckList[i].startStationId) {
                  if (this.shiftPasspointsTemp[j].arrivePassengers === undefined || this.shiftPasspointsTemp[j].arrivePassengers.length === 0 || this.shiftPasspointsTemp[j].arrivePassengers === null) {
                    let arrivePassengers = []
                    let tempPassenger = {}
                    tempPassenger.name = this.toCheckList[i].userName
                    tempPassenger.reserveId = this.toCheckList[i].reserveId
                    arrivePassengers[0] = tempPassenger
                    this.shiftPasspointsTemp[j].arrivePassengers = arrivePassengers
                  } else {
                    let tempPassenger = {}
                    tempPassenger.name = this.toCheckList[i].userName
                    tempPassenger.reserveId = this.toCheckList[i].reserveId
                    this.shiftPasspointsTemp[j].arrivePassengers[this.shiftPasspointsTemp[j].arrivePassengers.length] = tempPassenger
                  }
                  break
                }
              }
              if (this.toCheckList[i].arrivePlaceType === 1) {
                passenger.stationLat = this.toCheckList[i].homeLat
                passenger.stationLng = this.toCheckList[i].homeLng
                passenger.arrivePassengers = []
                passenger.stopFlag = true
                // this.shiftPasspointsTemp.splice(1, 0, passenger)
                this.shiftPasspointsTemp.splice(this.shiftPasspointsTemp.length - 1, 0, passenger)
                passpointNum++
              } else {
                if (this.toCheckList[i].arrivePlaceType === 3) {
                  passenger.stationLat = this.toCheckList[i].arrivePlaceLat
                  passenger.stationLng = this.toCheckList[i].arrivePlaceLng
                  passenger.arrivePassengers = []
                  passenger.stopFlag = true
                  // this.shiftPasspointsTemp.splice(1, 0, passenger)
                  this.shiftPasspointsTemp.splice(this.shiftPasspointsTemp.length - 1, 0, passenger)
                  passpointNum++
                }
              }
            }
          }
        }
      }
      this.passpointNum = passpointNum
      console.log(this.shiftPasspointsTemp)
      // 调规划路线的规划方法
      // 调规划路线将乘客上车位置放置对应ルート位置中
      let latLngList = []
      // 行便（只规划出发地到第一个停留所之间的经由地）
      if (this.goBackFlag === '0') {
        for (let i = 0; i < this.passpointNum + 2; i++) {
          let latLngObject = {}
          latLngObject.lat = this.shiftPasspointsTemp[i].stationLat
          latLngObject.lng = this.shiftPasspointsTemp[i].stationLng
          latLngList[i] = latLngObject
        }
      } else {
        // 帰り（只规划最后一个停留所到终着点之间的经由地）
        for (let i = this.shiftPasspointsTemp.length - (this.passpointNum + 2); i < this.shiftPasspointsTemp.length; i++) {
          let latLngObject = {}
          latLngObject.lat = this.shiftPasspointsTemp[i].stationLat
          latLngObject.lng = this.shiftPasspointsTemp[i].stationLng
          latLngList[i - (this.shiftPasspointsTemp.length - (this.passpointNum + 2))] = latLngObject
        }
      }
      console.log(latLngList)
      PlannRoute(latLngList, true).then(response => {
        // 请求后台获取到规划后的位置
        let order = response[response.length - 1].order
        // let order = response.data.route[0].waypointOrder
        let tempShiftPasspoints = []
        console.log(response)
        console.log(order)

        // 交换路线上对应点 ，并添加index属性
        // 停留所下标
        let stationNum = 1
        // 经由地下标
        let passengerNum = 1
        for (let i = 0; i < this.shiftPasspointsTemp.length; i++) {
          if (i === 0) {
            tempShiftPasspoints[i] = this.shiftPasspointsTemp[i]
            tempShiftPasspoints[i].index = 'S'
          } else if (i === this.shiftPasspointsTemp.length - 1) {
            tempShiftPasspoints[i] = this.shiftPasspointsTemp[i]
            tempShiftPasspoints[i].index = 'G'
          } else {
            // 行り  (交换出发地到第一个停留所之间的经由地)
            if (this.goBackFlag === '0') {
              // 交换经由地
              if (i < this.passpointNum + 1) {
                let j = Number(order[i - 1]) + 1
                tempShiftPasspoints[i] = this.shiftPasspointsTemp[j]
              } else {
                // 停留所保持不变
                tempShiftPasspoints[i] = this.shiftPasspointsTemp[i]
              }
            } else {
              // 帰り（交换最后一个停留所到终着点之间的经由地）
              if (i > this.shiftPasspointsTemp.length - (this.passpointNum + 2) && i < this.shiftPasspointsTemp.length - 1) {
                // 交换经由地
                // let j = Number(order[i - 1]) + 1
                // tempShiftPasspoints[i] = this.shiftPasspointsTemp[j]
                tempShiftPasspoints[i] = this.shiftPasspointsTemp[this.shiftPasspointsTemp.length - 1 - (this.passpointNum - Number(order[i - (this.shiftPasspointsTemp.length - 1 - this.passpointNum)]))]
              } else {
                // 停留所保持不变
                tempShiftPasspoints[i] = this.shiftPasspointsTemp[i]
              }
            }
            if (tempShiftPasspoints[i].stationId !== '' && tempShiftPasspoints[i].stationId !== null && tempShiftPasspoints[i].stationId !== undefined) {
              tempShiftPasspoints[i].index = 'G' + (stationNum)
              stationNum++
            } else {
              tempShiftPasspoints[i].index = String(passengerNum)
              passengerNum++
              // alert(this.shiftPasspoints[i].index)
            }
          }

          // 只对出発予定時間和最后一个到着予定時間进行赋值操作
          if (i === 0 || i === this.shiftPasspointsTemp.length - 1) {
            // if (i === 0) {
            //   alert(tempShiftPasspoints[i].estimateTime)
            // }
            let hourMin = DateUtil.hourMin(tempShiftPasspoints[i].estimateTime).split(':')
            this.hourList[i] = hourMin[0]
            if (hourMin[1].charAt(0) === '0') {
              this.minuteList[i] = hourMin[1].charAt(1)
            } else {
              this.minuteList[i] = hourMin[1]
            }
          }

          // 给时、分集合赋值(将经由地时间置空)
          // if (tempShiftPasspoints[i].estimateTime === '' || tempShiftPasspoints[i].estimateTime === null || tempShiftPasspoints[i].stationId === undefined) {
          //   // this.hourList[i] = ''
          //   // this.minuteList[i] = ''
          // } else {
          //   let hourMin = DateUtil.hourMin(tempShiftPasspoints[i].estimateTime).split(':')
          //   this.hourList[i] = hourMin[0]
          //   if (hourMin[1].charAt(0) === '0') {
          //     this.minuteList[i] = hourMin[1].charAt(1)
          //   } else {
          //     this.minuteList[i] = hourMin[1]
          //   }
          // }
        }

        this.shiftPasspoints = tempShiftPasspoints
        // 根据出発予定時間和最后一个到着予定時間自动计算各个到着予定时间
        this.computeValidate()
        console.log('[[----------')
        console.log(this.hourList)
        console.log(this.minuteList)
        // this.shif = this.shiftPasspointsTemp
        // this.shiftPasspoints = this.shiftPasspointsTemp
      }).catch(error => {
        console.log(error)
      })

      // this.shiftPasspoints = this.shiftPasspointsTemp
    },
    // 時間を自動計算する
    computeValidate () {
      this.$validator.validateAll().then(result => {
        if (result) {
          // if (this.timeValidate()) {
          let latLngList = []

          if (this.goBackFlag === '0') {
            for (let i = this.shiftPasspoints.length - 1; i >= 0; i--) {
              let latLngObject = {}
              latLngObject.lat = this.shiftPasspoints[i].stationLat
              latLngObject.lng = this.shiftPasspoints[i].stationLng
              latLngList[this.shiftPasspoints.length - 1 - i] = latLngObject
            }
          } else {
            for (let i = 0; i < this.shiftPasspoints.length; i++) {
              let latLngObject = {}
              latLngObject.lat = this.shiftPasspoints[i].stationLat
              latLngObject.lng = this.shiftPasspoints[i].stationLng
              latLngList[i] = latLngObject
            }
          }
          PlannRoute(latLngList, false)
            .then(response => {
              console.log(latLngList)
              // 自动推算乘车预定时间
              if (this.goBackFlag === '0') {
              // 重组选定的自动计算時間的基时间（最后一个时间）
                let estimateHour = this.hourList[this.hourList.length - 1] < 10 ? '0' + this.hourList[this.hourList.length - 1] : this.hourList[this.hourList.length - 1]
                let estimateMinute = this.minuteList[this.minuteList.length - 1] < 10 ? '0' + this.minuteList[this.minuteList.length - 1] : this.minuteList[this.minuteList.length - 1]
                let lastEstimateTime = estimateHour + ':' + estimateMinute
                let time = DateUtil.planTimeList(response, lastEstimateTime, this.goBackFlag)
                console.log(time)

                // 显示当前自动计算时间
                let j = 0
                for (let i = this.shiftPasspoints.length - 2; i >= 0; i--) {
                  this.$set(this.hourList, i, time[j].hour)
                  this.$set(this.minuteList, i, time[j].min)
                  j++
                }
              } else {
              // 重组选定的自动计算時間的基时间（第一个时间）
                let estimateHour = this.hourList[0] < 10 ? '0' + this.hourList[0] : this.hourList[0]
                let estimateMinute = this.minuteList[0] < 10 ? '0' + this.minuteList[0] : this.minuteList[0]
                let lastEstimateTime = estimateHour + ':' + estimateMinute
                let time = DateUtil.planTimeList(response, lastEstimateTime, this.goBackFlag)
                // 显示当前自动计算时间
                for (let i = 1; i < this.shiftPasspoints.length; i++) {
                  this.$set(this.hourList, i, time[i - 1].hour)
                  this.$set(this.minuteList, i, time[i - 1].min)
                }
              }
            })
            .catch(error => {
              console.log(error)
            })
            .catch(error => {
              console.log(error)
            })
        }
      })
    },
    // 判断是否是最后一个经由地
    checkLast (passIndex) {
      return passIndex !== String(this.passpointNum)
    },
    // 向上箭头操作：即上升当前passpoint位置,其中key：在shiftPasspoints中的下标，index为shiftPasspoint.index(与上面相邻对象交换，不要忘记时间的操作？？？)
    upPassPoint (nowKey, nowIndex) {
      this.showDialog = true
      this.$refs.dialog.confirm().then(() => {
        let upIndex = String(Number(nowIndex) - 1)
        let upKey = 0
        for (let i = 0; i < this.shiftPasspoints.length; i++) {
          if (this.shiftPasspoints[i].index === upIndex) {
            upKey = i
            break
          }
        }

        // 交换两者在数组的位置,并修改index
        this.shiftPasspoints[upKey].index = nowIndex
        this.shiftPasspoints[nowKey].index = upIndex
        let tempShiftPasspoint = this.shiftPasspoints[upKey]
        this.shiftPasspoints[upKey] = this.shiftPasspoints[nowKey]
        this.shiftPasspoints[nowKey] = tempShiftPasspoint
        this.showDialog = false
      }).catch(() => {
        this.showDialog = false
      })
    },
    // 向下箭头操作：即下降当前passpoint位置
    downPassPoint (nowKey, nowIndex) {
      this.showDialog = true
      this.$refs.dialog.confirm().then(() => {
        let downIndex = String(Number(nowIndex) + 1)
        let downKey = 0
        for (let i = 0; i < this.shiftPasspoints.length; i++) {
          if (this.shiftPasspoints[i].index === downIndex) {
            downKey = i
            break
          }
        }
        // 交换两者在数组的位置,并修改index
        this.shiftPasspoints[downKey].index = nowIndex
        this.shiftPasspoints[nowKey].index = downIndex
        let tempShiftPasspoint = this.shiftPasspoints[downKey]
        this.shiftPasspoints[downKey] = this.shiftPasspoints[nowKey]
        this.shiftPasspoints[nowKey] = tempShiftPasspoint
        this.showDialog = false
      }).catch(() => {
        this.showDialog = false
      })
    },
    // 获得在该停留所上车乘客的名字
    getPassengerNames (key) {
      let name = ''
      for (let i = 0; i < this.shiftPasspoints[key].arrivePassengers.length; i++) {
        if (i === this.shiftPasspoints[key].arrivePassengers.length - 1) {
          name = name + this.shiftPasspoints[key].arrivePassengers[i].name
        } else {
          name = name + this.shiftPasspoints[key].arrivePassengers[i].name + '、'
        }
      }
      return name
    },
    // 父组件保存时整合该组件的数据shiftPasspoints数组
    savePasspoints (moveShiftTime) {
      console.log("savePasspoints")
      console.log(moveShiftTime)
      let estimateTimeSlot
      for (let i = 0; i < this.shiftPasspoints.length; i++) {
        let hour = Number(this.hourList[i]) >= 10 ? this.hourList[i] : '0' + this.hourList[i]
        let minute = Number(this.minuteList[i]) >= 10 ? this.minuteList[i] : '0' + this.minuteList[i]
        let estimateTime = moveShiftTime + hour + minute + '00'
        console.log(estimateTime)
        this.shiftPasspoints[i].stationName = this.shiftPasspoints[i].name
        if (this.goBackFlag === '0') {
          // 行き
          if (i === 0) {
            // estimateTimeSlot = moveShiftTime + hour + '0000'
            estimateTimeSlot = estimateTime
            // this.shiftPasspoints[i].startEstimateTime = estimateTimeSlot // 按理为''
            // this.shiftPasspoints[i].arriveEstimateTime = ''
            // this.shiftPasspoints[i].estimateTime = estimateTimeSlot
            this.shiftPasspoints[i].startEstimateTime = estimateTime
            this.shiftPasspoints[i].arriveEstimateTime = ''
            this.shiftPasspoints[i].estimateTime = estimateTime
          } else {
            this.shiftPasspoints[i].startEstimateTime = ''
            this.shiftPasspoints[i].arriveEstimateTime = estimateTime
            this.shiftPasspoints[i].estimateTime = estimateTime
          }
        } else {
          // 帰り
          if (i === 0) {
            this.shiftPasspoints[i].startEstimateTime = estimateTime
            this.shiftPasspoints[i].arriveEstimateTime = ''
            this.shiftPasspoints[i].estimateTime = estimateTime
          } else {
            // if (i === this.shiftPasspoints.length - 1) {
            //   estimateTimeSlot = moveShiftTime + hour + '0000'
            estimateTimeSlot = estimateTime
            //   this.shiftPasspoints[i].startEstimateTime = ''
            //   this.shiftPasspoints[i].arriveEstimateTime = estimateTimeSlot // 按理为''
            //   this.shiftPasspoints[i].estimateTime = estimateTimeSlot
            // } else {
            this.shiftPasspoints[i].startEstimateTime = ''
            this.shiftPasspoints[i].arriveEstimateTime = estimateTime
            this.shiftPasspoints[i].estimateTime = estimateTime
            // }
          }
        }
      }

      // 更新被选中的キャンセル待ち预约者情报数组
      for (let i = 0; i < this.shiftReservationInfos.length; i++) {
        // 乗車予定日時
        if (this.shiftReservationInfos[i].startPlaceType === 2) {
          let stationId = this.shiftReservationInfos[i].startStationId
          let findshiftPasspoints = this.shiftPasspoints.filter((item) => (item.stationId === stationId && item.routeType === '0'))
          if (findshiftPasspoints.length === 1) {
            this.shiftReservationInfos[i].startEstimateTime = findshiftPasspoints[0].estimateTime
          }
        } else {
          let reserveId = this.shiftReservationInfos[i].reserveId
          let findshiftPasspoints = this.shiftPasspoints.filter((item) => item.reserveId === reserveId)
          if (findshiftPasspoints.length === 1) {
            this.shiftReservationInfos[i].startEstimateTime = findshiftPasspoints[0].estimateTime
          }
        }
        // 降車予定日時
        if (this.shiftReservationInfos[i].arrivePlaceType === 2) {
          let stationId = this.shiftReservationInfos[i].arriveStationId
          let findshiftPasspoints = this.shiftPasspoints.filter((item) => (item.stationId === stationId && item.routeType === '0'))
          if (findshiftPasspoints.length === 1) {
            this.shiftReservationInfos[i].arriveEstimateTime = findshiftPasspoints[0].estimateTime
          }
        } else {
          let reserveId = this.shiftReservationInfos[i].reserveId
          let findshiftPasspoints = this.shiftPasspoints.filter((item) => item.reserveId === reserveId)
          if (findshiftPasspoints.length === 1) {
            this.shiftReservationInfos[i].arriveEstimateTime = findshiftPasspoints[0].estimateTime
          }
        }
      }
      console.log("editorShiftPasspoints")
      console.log(this.shiftPasspoints)
      console.log(estimateTimeSlot)
      this.$emit('editorShiftPasspoints', this.shiftPasspoints, this.shiftReservationInfos, estimateTimeSlot, 0)
      this.$emit('getHour', this.hourList, 0)
      this.$emit('getMinute', this.minuteList, 0)
    },
    yyy () {
      // alert('pp')
    }
  }
}
</script>

<template>
    <div class="clearfix"  style="margin-top:-5px">
        <div class="clearfix" v-for="(shiftPasspoint,key) in shiftPasspoints" :key="key">
          <div class="col-md-7 column paddingTop">
            <div class="row clearfix">
            <div class="col-md-2 column divTitle shortDiv bgc8 F3-R-15"  style="width:22.2%">
              <div class="row clearfix">
                <div class="col-md-12 column clearfix" v-if="shiftPasspoint.index==='S'">
                  出発地
                </div>
                <div class="col-md-12 column clearfix" v-else-if="shiftPasspoint.index==='G'">
                  終着地
                </div>
                <div class="col-md-12 column clearfix" v-else-if="shiftPasspoint.routeType==='0'">
                  停留所{{shiftPasspoint.index.substring(1)}}
                </div>
                <div class="col-md-12 column clearfix" v-else>
                  経由地{{shiftPasspoint.index}}
                </div>
              </div>
             </div>
            <div class="col-md-4 column stationWidth" >
              <div class="divTitle longsolid passengerdiv F3-R-20 bgc5" v-if="shiftPasspoint.routeType==='1'">
                <div style="flex:8" class="overflow-fix">
                  {{shiftPasspoint.name}}
                </div>
                <div  class="upAbleArrow" v-if="shiftPasspoint.index!=='1'" @click="upPassPoint(key,shiftPasspoint.index)"></div> <div  class="upDisableArrow" v-else></div>
                <div  class="downAbleArrow" v-if="checkLast(shiftPasspoint.index)" @click="downPassPoint(key,shiftPasspoint.index)"></div><div  class="downDisableArrow" v-else></div>
              </div>
              <div class="divTitle longsolid F3-R-20 bgc5 overflow-fix" v-else-if="shiftPasspoint.arrivePassengers!==undefined &&shiftPasspoint.arrivePassengers.length>0"> {{shiftPasspoint.name}} &nbsp;&nbsp;&nbsp;&nbsp; 乗車者：{{getPassengerNames(key)}}</div>
              <div class="divTitle longsolid F3-R-20 bgc5 overflow-fix" v-else> {{shiftPasspoint.name}}</div>
         </div>
            </div>
          </div>
             <div class="col-md-5 rightDivWidth paddingTop paddingBottom" :class="{bgc14:(shiftPasspoint.index==='S'&&goBackFlag==='1')
                        ||(shiftPasspoint.index==='G'&&goBackFlag==='0')}">
            <div class="row clearfix">
            <div class="col-md-4 column divTitle shortDiv bgc8 F3-R-15" style="width:35%;margin-left:10px">
              <div class="row clearfix">
                <div class="col-md-3 column clearfix" v-if="shiftPasspoint.index==='S'||shiftPasspoint.index==='G'">
                  ※
                </div>
                <div class="col-md-3 column clearfix" v-else>
                </div>
                <div class="col-md-9 column clearfix paddingLeftZero textAlignLeft" v-if="shiftPasspoint.index==='S'">
                  出発予定時間
                </div>
                <div class="col-md-9 column clearfix paddingLeftZero textAlignLeft" v-else>
                  到着予定時間
                </div>
              </div>
            </div>
            <div class="col-md-3 column paddingRightZero">
              <div class="clearfix">
              <!-- <select v-if="(shiftPasspoint.index==='S'&&goBackFlag==='0')||(shiftPasspoint.index==='G'&&goBackFlag==='1')"
              :class="{selectstyles:true, selectImg:true}"
              :name="`selectHour${key}`" v-validate="{required: shiftPasspoint.index==='S'||shiftPasspoint.index==='G'}"
              v-model="hourList[key]" @change="yyy()">
              <option v-for="n in 19" :key="n" :value="n+3">{{n+3>9?n+3:"0"+(n+3)}}</option>
              </select> -->
              <select :class="{selectstyles:true, selectImg:true}"
               :name="`selectHour${key}`" v-validate="{required: (shiftPasspoint.index==='S'&&goBackFlag==='0')||(shiftPasspoint.index==='G'&&goBackFlag==='1')}"
              v-model="hourList[key]">
              <option v-for="n in 24" :key="n" :value="n-1">{{n-1>9?n-1:"0"+(n-1)}}</option>
              </select>
              </div>
             <div class="clearfix" style="width:175%">
                <span v-if="errors.has(`selectHour${key}`)" class="errorMessage"> {{ errors.first(`selectHour${key}`) }} </span>
                <span v-else-if="errors.has(`selectMinute${key}`)" class="errorMessage"> {{ errors.first(`selectMinute${key}`) }} </span>
                <!-- <span v-else-if="((shiftPasspoint.index==='S'&&goBackFlag==='1')||(shiftPasspoint.index==='G'&&goBackFlag==='0'))&&timeValidateFlag" class="errorMessage">
                   必須入力項目が未入力です。
                </span> -->
              </div>
            </div>
             <!-- <div class="col-md-1 column aloneWordDiv F3-R-17" style="width:11%"
              v-if="(shiftPasspoint.index==='S'&&goBackFlag==='0')||(shiftPasspoint.index==='G'&&goBackFlag==='1')">
              時台
            </div> -->
             <div class="col-md-1 column aloneWordDiv timeWidth F3-R-17">
              時
            </div>
             <div class="col-md-3 column paddingLeftZero">
              <select :class="{selectstyles:true, selectImg:true}"
               :name="`selectMinute${key}`"
               v-validate="{required: (shiftPasspoint.index==='S'&&goBackFlag==='0')||(shiftPasspoint.index==='G'&&goBackFlag==='1')}"
               v-model="minuteList[key]">
              <option v-for="n in 60" :key="n" :value="n-1">{{n-1>9?n-1:"0"+(n-1)}}</option>
              </select>
            </div>
             <!-- <div class="col-md-3 column paddingLeftZero"
              v-show="(shiftPasspoint.index!=='S'&&goBackFlag==='0')||(shiftPasspoint.index!=='G'&&goBackFlag==='1')">
              <select :class="{selectstyles:true, selectImg:true}"
               :name="`selectMinute${key}`"
               v-validate="{required: (shiftPasspoint.index==='S'&&goBackFlag==='1')||(shiftPasspoint.index==='G'&&goBackFlag==='0')}"
               v-model="minuteList[key]">
              <option v-for="n in 60" :key="n" :value="n-1">{{n-1>9?n-1:"0"+(n-1)}}</option>
              </select>
            </div> -->
             <div class="col-md-1 column aloneWordDiv timeWidth F3-R-17" style="margin-left: -15px">
              分
            </div>
             <!-- <div class="col-md-1 column aloneWordDiv timeWidth F3-R-17" style="margin-left: -15px"
              v-show="(shiftPasspoint.index!=='S'&&goBackFlag==='0')||(shiftPasspoint.index!=='G'&&goBackFlag==='1')">
              分
            </div> -->
            </div>
          </div>
        </div>
        <div class="clearfix" v-if="timeError === true">
          <div class="col-md-7 column">
          </div>
          <div class="col-md-5 column errorMessage paddingTop paddingBottom rightDivWidth">
            入力時間の順序が不正です。
          </div>
        </div>
        <div class="clearfix" v-if="shiftTimeError === true">
          <div class="col-md-7 column">
          </div>
          <div class="col-md-5 column errorMessage paddingTop paddingBottom rightDivWidth">
            未入力の項目があります。
          </div>
        </div>
        <div class="clearfix">
          <div class="col-md-7 column">
          </div>
          <div class="col-md-5 column rightDivWidth paddingTop bgc15" style="z-index: 2;">
            <div class="row clearfix">
            <button class="T7-radius F2-R" @click="computeValidate">
            時間を自動計算する
            </button>
            </div>
            <div class="row clearfix F2-R" style="margin-top:5px">
              <div class="col-md-1 column clearfix paddingRightZero">
                ※
              </div>
              <div class="col-md-11 column clearfix textAlignLeft paddingLeftZero">
                赤枠の時刻を入力した後、「時間を自動計算する」ボタンを押してください
              </div>
            </div>
          </div>
        </div>
        <v-dialog v-show="showDialog" :dialog-option="dialogOption" ref="dialog"></v-dialog>
    </div>
</template>

<style scoped>
.divTitle {
  height: 50px;
  line-height: 50px;
}
.T7-radius {
  width: 100%;
  max-width: 250px;
  height: 40px;
  background: linear-gradient(#888886 50%, #696a65 50%) !important;
  border-radius: 30px;
  text-align: center;
  padding: 0;
  border: 0;
}
.selectstyles {
  border: solid 1px #ccc;
  border-radius: 10px;
  width: 100%;
  height: 50px;
  line-height: 20px;
  font-size: 16px;
  text-align: left;
  padding-left: 12px;
  background-color: white !important;
}
.selectImg {
  outline:none;
  float: right;
  text-indent: 1px;
  -moz-appearance:none;
  -webkit-appearance:none;
  background: url("../assets/dropselect.png") no-repeat scroll right center transparent;
}
.longsolid {
  padding: 0px 12px;
  text-align: left;
}
.textAlignLeft {
  text-align: left;
}
.paddingLeftZero {
  padding-left: 0px;
}
.paddingRightZero {
  padding-right: 0px;
}
.stationWidth {
  width: 77%;
}
.shortDiv {
  width: 13%;
  min-width: 120px;
}
.divMarginTop {
  margin-top: 10px;
}
.aloneWordDiv{
  display:flex;
  align-items:center;
  justify-content:center;
  height:50px;
  padding-left: 0px;
  padding-right: 0px;
}

/* 关于值的列的设置（浅色） */
.stopFlaseValue{
  /* border: 1px solid #959595; */
  /* color:#bbbbbb; */
  color:#bbbbbb;
}
.passengerdiv {
  display: flex;
  flex-direction: row;
}
.upAbleArrow{
  margin-top: 5px;
  height: 40px;
  width:40px;
  margin-right: 3px;
  background: url("../assets/button/list_up_button1.png") no-repeat scroll right center transparent;
}
.upDisableArrow{
  margin-top: 5px;
  height: 40px;
  width:40px;
  margin-right: 3px;
  background: url("../assets/button/list_up_button2.png") no-repeat scroll right center transparent;
}
.downAbleArrow{
  margin-top: 5px;
  height: 40px;
  width: 40px;
  margin-right: -5px;
  background: url("../assets/button/list_down_button1.png") no-repeat scroll right center transparent;
}
.downDisableArrow{
  margin-top: 5px;
  height: 40px;
  width: 40px;
  margin-right: -5px;
  background: url("../assets/button/list_down_button2.png") no-repeat scroll right center transparent;
}
.errorMessage {
  color: red;
}
.rightDivWidth{
  width:37%;
}
.paddingTop{
  padding-top: 5px;
}
.paddingBottom{
  padding-bottom: 5px;
}
.timeWidth{
  width: 7%;
}
</style>



// WEBPACK FOOTER //
// src/components/ShiftAddComponent.vue